import { InjectionToken } from '@angular/core';

import { FirebaseOptions } from 'firebase/app';
import { Messaging } from 'firebase/messaging';

interface FirebaseConfig extends FirebaseOptions {
  vapidKey: string;
}

export const FIREBASE_CONFIG = new InjectionToken<FirebaseConfig>('FIREBASE_CONFIG');
export const FIREBASE_API_URL = new InjectionToken<string>('FIREBASE_API_URL');
export const FIREBASE_MESSAGING = new InjectionToken<Messaging>('FIREBASE_MESSAGING');
